import CartActions from '@/components/CartActions/CartActions.vue';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown';
import { setupI18n } from '@/shared/utils/i18n';

export const initCartActions = async (createApp, mountId) => {
  if (!document.getElementById(mountId)) {
    return;
  }

  const i18n = await setupI18n(window.Shopify.locale);

  const vueApp = createApp(CartActions);
  vueApp.use(window.hobbiiStore);

  vueApp
    .use(i18n)
    .directive('global-keydown', GlobalKeyDownDirective)
    .mount(`#${mountId}`);
};
